exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat+Alternates);", ""]);

// module
exports.push([module.id, ".page[data-v-e863702a],.results-col[data-v-e863702a]{display:flex;flex-direction:column}.page[data-v-e863702a]{width:100%;height:100%;margin-top:0}.sub-page-main[data-v-e863702a]{margin-top:50px;padding-top:10px}.nav-bar[data-v-e863702a]{box-shadow:0 .5px 2px .5px #555;position:fixed}.results-col[data-v-e863702a]{width:80%;padding-left:15px;padding-right:5px;padding-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e863702a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Views/SearchResults.vue
// module id = 42
// module chunks = 0